import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

/**
 * Merge Tailwind class names safely.
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Note: hasEnvVars has been moved to lib/env.ts for Edge runtime compatibility
// Re-export it here for backwards compatibility in client/server components
export { hasEnvVars } from "./env";

/**
 * Dynamically determines the app URL based on environment variables.
 *
 * Priority:
 * 1. NEXT_PUBLIC_APP_URL (should always be set in Railway/production)
 * 2. Client-side: window.location.origin (runtime fallback)
 * 3. Server-side: http://localhost:3000 (local development fallback)
 *
 * Note: In client components, NEXT_PUBLIC_* env vars are bundled at build time.
 */
export function getAppUrl(): string {
  if (process.env.NEXT_PUBLIC_APP_URL) {
    return process.env.NEXT_PUBLIC_APP_URL
  }

  // Client-side: Use window.location.origin as fallback
  if (typeof window !== "undefined") {
    return window.location.origin
  }

  // Server-side fallback for local development
  return "http://localhost:3000"
}
